
const anniversary2021 = resolve => require(['@/page/anniversary2021/index'], resolve);
const anniversary2021hall = resolve => require(['@/page/anniversary2021/hall'], resolve);
const anniversary2021mylottery = resolve => require(['@/page/anniversary2021/mylottery'], resolve);
const anniversary2021stree = resolve => require(['@/page/anniversary2021/stree'], resolve);
const anniversary2021memorial = resolve => require(['@/page/anniversary2021/memorial'], resolve);

export default [
  {
    path: '/anniversary2021',
    name: 'anniversary2021',
    component: anniversary2021,
    // meta:{
    //   keepAlive:true
    // }
  },
  {
    path: '/anniversary2021/hall',
    name: 'anniversary2021hall',
    component: anniversary2021hall,
   
  },
  {
    path: '/anniversary2021/mylottery',
    name: 'anniversary2021mylottery',
    component: anniversary2021mylottery,
    
  },
  {
    path: '/anniversary2021/stree',
    name: 'anniversary2021stree',
    component: anniversary2021stree,
    
   
  },
  {
    path: '/anniversary2021/memorial',
    name: 'anniversary2021memorial',
    component: anniversary2021memorial,
   
  }
];


// WEBPACK FOOTER //
// ./src/router/anniversary2021.js